import ConfirmationPopover from "@/appComponents/Blocks/Composites/ConfirmationPopover/ConfirmationPopover";
import { Flex, Text } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

export const ChangeChartTypePopover = ({ handleChange, reference, dataTestPrefix }) => {
  return (
    <ConfirmationPopover
      onSubmit={handleChange}
      iconOnly
      iconProps={{ size: "small" }}
      otherHeaderProps={{ title: appstr("Switch chart types") }}
      confirmLabel={appstr("Yes")}
      popoverProps={{ reference }}
      dataTestPrefix={dataTestPrefix}
    >
      <Flex gap={"12px"} direction={"column"}>
        <Text>{appstr("Switch chart type (long)")}</Text>
      </Flex>
    </ConfirmationPopover>
  );
};
